import React, { useCallback, useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { useFormsContext } from 'pages/forms/context/FormsProvider';
import { useStyles } from './styles';
import { IconButton } from '@material-ui/core';
import { ConfirmationModal } from './ConfirmationModal';
import { retrieveValidParams } from 'utils/http';

interface IProps {
  rowIndex: number;
}

export const DeleteButton = ({ rowIndex }: IProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, loadCancelForm, isLoadingCancelForm, loadForms, filter } = useFormsContext();
  const styles = useStyles();

  const handleModal = useCallback(() => {
    setIsModalOpen(!isModalOpen);
  }, [isModalOpen]);

  const rowData = useMemo(() => {
    return data[rowIndex];
  }, [data, rowIndex]);

  const handleConfirmation = useCallback(async () => {
    const id = rowData.idForm;
    await loadCancelForm({ id }).then(async () => {
      handleModal();
      const params = retrieveValidParams(filter);
      await loadForms(params);
    });
  }, [rowData, loadCancelForm, handleModal]);

  const isButtonDisabled = useMemo(() => {
    if (!rowData) return false;
    return rowData.inCanceled === 'S';
  }, [rowData]);

  return (
    <>
      <ConfirmationModal
        isOpen={isModalOpen}
        onCloseModal={handleModal}
        onConfirm={handleConfirmation}
        isLoading={isLoadingCancelForm}
      />
      <IconButton disabled={isButtonDisabled} onClick={handleModal} className={styles.button}>
        <FontAwesomeIcon icon={faTrash} />
      </IconButton>
    </>
  );
};
